<ion-header class="coupon-card-modal__header">
  <img class="coupon-card-modal__header__icon" src="assets/app-logo/ocm.png" alt="company logo" />
  <shared-close class="coupon-card-modal__header__close" (tap)="dismiss(null)"></shared-close>
</ion-header>
<ion-content padding>
  <ocm-coupon-card [ticketSelected]="ticketSelected" (RedeemEvent)="dismiss($event)"></ocm-coupon-card>
</ion-content>
